module.exports = __webpack_public_path__ + "img/finished-stage.578ebff9.png";